/**
* 绑定题目
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>绑定题目</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="searchForm" class="user-search">
      <el-form-item label="维度">
        <el-select size="small" v-model="searchForm.parentId" placeholder="请选择维度">
          <el-option
            v-for="item in statisticMethodList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="名称">
        <el-input size="small" v-model="searchForm.name" placeholder="名称" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column prop="type" label="简称" width="60">
      </el-table-column>
      <el-table-column prop="name" label="名称" width="60">
      </el-table-column>
      <el-table-column prop="parentId" label="所属维度" width="100" :formatter="weiDuFormatter">
      </el-table-column>
      <el-table-column prop="questionBankId" label="所属题库" width="100" :formatter="parentFormatter">
      </el-table-column>
      <el-table-column label="图片(男)" width="150">
        <template slot-scope="scope">
          <el-image style="width: 100px; height: 100px" :src="scope.row.malePic" :fit="fit" v-if="scope.row.malePic"></el-image>
          <div v-else>未上传图片</div>
        </template>
      </el-table-column>
      <el-table-column label="图片(女)" width="150">
        <template slot-scope="scope">
          <el-image style="width: 100px; height: 100px" :src="scope.row.femalePic" :fit="fit" v-if="scope.row.femalePic"></el-image>
          <div v-else>未上传图片</div>
        </template>
      </el-table-column>
      <el-table-column prop="questionDetailIds" label="题目序号">
      </el-table-column>
      <el-table-column align="center" label="操作" width="300">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" @click="handleQuestion(scope.$index, scope.row)">题目</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="所属维度" prop="parentId">
          <el-select size="small" v-model="editForm.parentId" placeholder="请选择维度">
            <el-option
              v-for="item in statisticMethodList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="简称" prop="type">
          <el-input size="small" v-model="editForm.type" auto-complete="off" placeholder="请输入简称"></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input size="small" v-model="editForm.name" auto-complete="off" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="全称" prop="fullName">
          <el-input size="small" v-model="editForm.fullName" auto-complete="off" placeholder="请输入全称"></el-input>
        </el-form-item>
        <el-form-item label="阐述一" prop="explain1">
          <el-input size="small" v-model="editForm.explain1" type="textarea" auto-complete="off"
                    placeholder="请输入阐述一"></el-input>
        </el-form-item>
        <el-form-item label="阐述二" prop="explain2">
          <el-input size="small" v-model="editForm.explain2" type="textarea" auto-complete="off"
                    placeholder="请输入阐述二"></el-input>
        </el-form-item>
        <el-form-item label="阐述三" prop="explain3">
          <el-input size="small" v-model="editForm.explain3" type="textarea" auto-complete="off"
                    placeholder="请输入阐述三"></el-input>
        </el-form-item>
        <el-form-item label="职业特长" prop="special1">
          <el-input size="small" v-model="editForm.special1" type="textarea" auto-complete="off"
                    placeholder="请输入职业特长"></el-input>
        </el-form-item>
        <el-form-item label="职业信念" prop="special2">
          <el-input size="small" v-model="editForm.special2" type="textarea" auto-complete="off"
                    placeholder="请输入职业信念"></el-input>
        </el-form-item>
        <el-form-item label="职业盲区" prop="special3">
          <el-input size="small" v-model="editForm.special3" type="textarea" auto-complete="off"
                    placeholder="请输入职业盲区"></el-input>
        </el-form-item>
        <el-form-item label="图片(男)" prop="malePic">
          <el-upload
            class="avatar-uploader"
            action="/api/upload/img"
            :headers="headerToken"
            :show-file-list="false"
            :on-success="handleMalePicSuccess"
            :before-upload="beforeMalePicUpload">
            <img v-if="editForm.malePic" :src="editForm.malePic" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="图片(女)" prop="femalePic">
          <el-upload
            class="avatar-uploader"
            action="/api/upload/img"
            :headers="headerToken"
            :show-file-list="false"
            :on-success="handleFemalePicSuccess"
            :before-upload="beforeFemalePicUpload">
            <img v-if="editForm.femalePic" :src="editForm.femalePic" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存
        </el-button>
      </div>
    </el-dialog>
    <!-- 绑定题目 -->
    <el-dialog :title="title" :visible.sync="questionFormVisible" width="50%" @click="closeQuestionDialog">
      <el-form label-width="120px" :model="editQuestionForm" :rules="rules" ref="editQuestionForm">
        <div style="height: 750px;overflow: auto;">
          <el-tree
            ref="tree"
            :data="treeData"
            show-checkbox
            node-key="id"
            :default-expanded-keys="[0]"
            :default-checked-keys="checkedKey"
            check-on-click-node
            @check="currentChecked">
          </el-tree>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeQuestionDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitQuestionForm">保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  questionBankList,
  questionListByMethod,
  statisticMethodDetailDelete,
  statisticMethodDetailList,
  statisticMethodDetailSave,
  statisticMethodDetailRelationSave,
  statisticMethodList
} from '../../api/api'
import Pagination from '../../components/Pagination'
import {getCookie} from "../../utils/util";

export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      questionFormVisible: false,
      // 维度下拉
      statisticMethodList: [],
      title: '添加',
      editForm: {
        id: '',
        parentId: '',
        type: '',
        name: '',
        fullName: '',
        explain1: '',
        explain2: '',
        explain3: '',
        special1: '',
        special2: '',
        special3: '',
        malePic: '',
        femalePic: ''
      },
      editQuestionForm: {
        id: '',
        questionDetailIds: ''
      },
      // rules表单验证
      rules: {
        id: [
          {required: true, message: '请选择维度', trigger: 'blur'}
        ],
        type: [
          {required: true, message: '请选择维度', trigger: 'blur'}
        ],
        name: [
          {required: true, message: '请输入名称', trigger: 'blur'}
        ],
        fullName: [
          {required: true, message: '请输入名称', trigger: 'blur'}
        ],
        explain1: [
          {required: true, message: '请输入名称', trigger: 'blur'}
        ],
        explain2: [
          {required: true, message: '请输入名称', trigger: 'blur'}
        ],
        explain3: [
          {required: true, message: '请输入名称', trigger: 'blur'}
        ],
        special1: [
          {required: true, message: '请输入名称', trigger: 'blur'}
        ],
        special2: [
          {required: true, message: '请输入名称', trigger: 'blur'}
        ],
        special3: [
          {required: true, message: '请输入名称', trigger: 'blur'}
        ]
      },
      searchForm: {
        parentId: '',
        name: ''
      },
      // 删除部门
      seletedata: {
        ids: ''
      },
      fit: 'fill',
      listData: [], //用户数据
      treeData: [{
        id: 0,
        label: '全部',
        children: []
      }],
      // 题库下拉
      questionBankList: [],
      headerToken: {"token": getCookie('access_token')},
      checkedKey: [],
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.questionBankDropDown();
    //this.getStatisticMethodList();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 
    questionBankDropDown() {
      questionBankList({deleteFlg: 0})
        .then(res => {
          this.questionBankList = res.data;
          if (this.questionBankList && this.questionBankList.length > 0) {
            this.searchForm.questionBankId = this.questionBankList[0].id
          }
          this.getStatisticMethodList();
        })
        .catch(err => {
          this.loading = false
          this.$message.error('下拉列表查询失败！')
        })
    },
    getStatisticMethodList() {
      statisticMethodList({deleteFlg: 0})
        .then(res => {
          this.statisticMethodList = res.data;
          this.searchForm.parentId = res.data[0].id;
          this.getData(this.searchForm);
        })
        .catch(err => {
          this.loading = false
          this.$message.error('下拉列表查询失败！')
        })
    },
    // 获取维度详情列表 
    getData(parameter) {
      this.loading = true
      statisticMethodDetailList(parameter)
        .then(res => {
          this.loading = false
          this.listData = res.data;
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    // 搜索事件
    search() {
      if (!this.searchForm.parentId) {
        this.$message.error('请选择维度！')
        return;
      }
      this.getData(this.searchForm)
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      let _this = this;
      _this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        _this.title = '修改'
        _this.editForm.id = row.id
        _this.editForm.parentId = row.parentId;
        _this.editForm.questionBankId = row.questionBankId;
        _this.editForm.type = row.type;
        _this.editForm.name = row.name
        _this.editForm.fullName = row.fullName;
        _this.editForm.explain1 = row.explain1;
        _this.editForm.explain2 = row.explain2;
        _this.editForm.explain3 = row.explain3;
        _this.editForm.special1 = row.special1;
        _this.editForm.special2 = row.special2;
        _this.editForm.special3 = row.special3;
        _this.editForm.malePic = row.malePic;
        _this.editForm.femalePic = row.femalePic;
      } else {
        _this.title = '添加';
        _this.editForm.id = '';
        _this.editForm.parentId = '';
        _this.editForm.questionBankId = '';
        _this.editForm.type = '';
        _this.editForm.name = '';
        _this.editForm.fullName = '';
        _this.editForm.explain1 = '';
        _this.editForm.explain2 = '';
        _this.editForm.explain3 = '';
        _this.editForm.special1 = '';
        _this.editForm.special2 = '';
        _this.editForm.special3 = '';
        _this.editForm.malePic = '';
        _this.editForm.femalePic = '';
        // this.$refs('editForm').resetFields();
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          statisticMethodDetailSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code === 200) {
                this.getData(this.searchForm)
                this.$message({
                  type: 'success',
                  message: '详情保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('详情保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除详情
    handleDelete(index, row) {
      let _this = this;
      _this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        statisticMethodDetailDelete(row.id)
          .then(res => {
            if (res.code === 200) {
              _this.$message({
                type: 'success',
                message: '详情已删除!'
              })
              _this.getData(_this.searchForm)
            } else {
              _this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            _this.loading = false
            _this.$message.error('详情删除失败，请稍后再试！')
          })
      })
        .catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    },
    // 关闭编辑、增加弹出框
    closeQuestionDialog() {
      this.questionFormVisible = false
    },
    // 关闭编辑、增加弹出框
    submitQuestionForm() {
      let _this = this;
      _this.editQuestionForm.questionDetailIds = _this.checkedKey.filter(item => item !== 0).join(',');
      statisticMethodDetailRelationSave(_this.editQuestionForm)
        .then(res => {
          _this.questionFormVisible = false
          if (res.code === 200) {
            _this.getData(_this.searchForm)
            _this.$message({type: 'success', message: '题目保存成功！'})
          } else {
            _this.$message({type: 'info', message: res.msg})
          }
        }).catch(err => {
        _this.questionFormVisible = false
        _this.loading = false
        _this.$message.error('题目保存失败，请稍后再试！')
      })
    },
    // 题目
    handleQuestion(index, row) {
      let _this = this;
      _this.treeData[0].children = [];
      _this.checkedKey = [];
      _this.questionFormVisible = true
      _this.editQuestionForm.id = row.id;
      if (row.questionDetailList) {
        _this.checkedKey = row.questionDetailList.map(item => item.id);
      }
      let parameter = {'questionBankId': row.questionBankId, 'statisticMethodId': row.parentId, 'statisticMethodDetailId': row.id}
      questionListByMethod(parameter).then(res => {
        if (res.code === 200) {
          let arr = [];
          res.data.forEach(function (item, index) {
            let arrItem = {
              id: item.id,
              label: item.orders + '.' + item.name,
              disabled: item.disableStatus == 1
            };
            arr.push(arrItem);
          });
          _this.treeData[0].children = arr;
          _this.$nextTick(() => {
            _this.$refs.tree.setCheckedKeys(_this.checkedKey);
          });
        }
      }).catch(err => {
        _this.loading = false
        _this.$message.error('查询失败！')
      })
    },
    // 题库格式化
    weiDuFormatter(row, column, cellValue, index) {
      const item = this.statisticMethodList.find(item => item.id === cellValue)
      return item ? item.name : cellValue
    },
    // 题库格式化
    parentFormatter(row, column, cellValue, index) {
      const item = this.questionBankList.find(item => item.id === cellValue)
      return item ? item.name : cellValue
    },
    // 照片上传成功
    handleMalePicSuccess(res, file) {
      this.editForm.malePic = "images/" + res.data;
    },
    // 照片上传前验证
    beforeMalePicUpload(file) {

    },
    // 照片上传成功
    handleFemalePicSuccess(res, file) {
      this.editForm.femalePic = "images/" + res.data;
    },
    // 照片上传前验证
    beforeFemalePicUpload(file) {

    },
    currentChecked(nodeObj, SelectedObj) {
      this.checkedKey = SelectedObj.checkedKeys;
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/scoreRule/SetQuestion.vue